const DEFAULT_POST_LOGIN_HASH = "#/perfil";

function normalizeHashPath(value: string) {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("#/")) return trimmed;
  if (trimmed.startsWith("/")) return `#${trimmed}`;
  return "";
}

function isLoginRoute(hash: string) {
  return hash.toLowerCase().startsWith("#/login");
}

export function buildLoginHref(nextHash: string) {
  const normalizedNextHash = normalizeHashPath(nextHash);
  if (!normalizedNextHash || isLoginRoute(normalizedNextHash)) {
    return "#/login";
  }
  const query = new URLSearchParams({ next: normalizedNextHash });
  return `#/login?${query.toString()}`;
}

export function resolvePostLoginHash(
  loginHash: string,
  fallbackHash = DEFAULT_POST_LOGIN_HASH,
) {
  const normalizedFallback = normalizeHashPath(fallbackHash) || DEFAULT_POST_LOGIN_HASH;
  const [, queryPart = ""] = String(loginHash || "").split("?");
  const query = new URLSearchParams(queryPart);
  const requestedNextHash = normalizeHashPath(String(query.get("next") || ""));
  if (!requestedNextHash || isLoginRoute(requestedNextHash)) {
    return normalizedFallback;
  }
  return requestedNextHash;
}
